document.addEventListener("DOMContentLoaded", function () {
  const swiperEl = document.querySelector(".swiper-mobile");

  if (!swiperEl) return;

  let swiperMb;

  function initSwiper() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      if (!swiperMb) {
        const preview = parseInt(swiperEl.dataset.preview) || 1;
        const mobileSm = parseInt(swiperEl.dataset.mobileSm) || preview;
        const spacing = Number(swiperEl.dataset.space ?? 15);
        swiperMb = new Swiper(".swiper-mobile", {
          slidesPerView: preview,
          slidesPerGroup: preview,
          spaceBetween: spacing,
          speed: 800,
          autoHeight: true,
          breakpoints: {
            575: {
              slidesPerView: mobileSm,
              slidesPerGroup: mobileSm
            }
          },
          pagination: {
            el: ".pagination-sw-mobile",
            clickable: true,
          },
          navigation: {
            nextEl: ".next-sw-mobile",
            prevEl: ".prev-sw-mobile",
          },
        });
      }
    } else {
      if (swiperMb) {
        swiperMb.destroy(true, true);
        swiperMb = null;

        const wrapper = swiperEl.querySelector(".swiper-wrapper");
        const slides = swiperEl.querySelectorAll(".swiper-slide");

        if (wrapper) wrapper.removeAttribute("style");
        slides.forEach((slide) => slide.removeAttribute("style"));
      }
    }
  }

  initSwiper();
  window.addEventListener("resize", initSwiper);
});